/**
 * This file can be replaced during build by using the `fileReplacements` array.
 *  The list of file replacements can be found in `angular.json`.
 * `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
 * environment variable is define for distinguise live key or UAT key.
 * 
 */
 export const environment = {
  /** for env identifier */
  production: false,
   /** Captcha key for authentication */
  gcaptchaKey: "6LdzZF4mAAAAADek_xDrXlH_JQqq5V1L2Unreg9t",
  /** passing xAPI key on every api for authentication */
  xapiKeys: {
    commonKey:
      "RGZLb3VUazZxVmxrcjZqajdNZFJTZE5IQlZnMVZYa1I6Y2VESVluYWJqbE4xa0JOMFBkb3hoWHUzb09rUTJKSFc=",
  }


};
